import { FormattedMessage } from 'react-intl'
import ConfirmationPopup from '../../popups/ConfirmationPopup'
import { useState } from 'react'
import { getCardBrandIcon } from '../helpers'
import { FormRadioButton } from '../../forms/final-form-fields/FormRadioGroup'

const CreditCardDetails = ({
  details,
  onDelete,
  isCheckout,
  objectId,
  selectedCard,
  onCreditCardSelect,
}) => {
  const [isConfirmationShown, setConfirmationShown] = useState(false)

  const onDeleteClick = () => {
    setConfirmationShown(true)
  }

  const onDeleteConfirm = () => {
    onDelete()
    setConfirmationShown(false)
  }

  const onDeleteReject = () => {
    setConfirmationShown(false)
  }

  return (
    <div className='credit-card'>
      {isCheckout && (
        <FormRadioButton
          type='radio'
          onChange={() => onCreditCardSelect(objectId, details.brand)}
          value={objectId}
          isNumericValue
          name='paymentMethodId'
        />
      )}
      <div className='credit-card-details'>
        <div className={getCardBrandIcon(details.brand)} />
        <p className='last-digits'>**** **** **** {details.last4}</p>
      </div>
      {!isCheckout && (
        <a className='credit-card-cta' onClick={onDeleteClick}>
          <FormattedMessage id='delete' defaultMessage='Delete' />
        </a>
      )}
      <ConfirmationPopup
        isOpen={isConfirmationShown}
        onConfirm={onDeleteConfirm}
        onReject={onDeleteReject}
      />
    </div>
  )
}

export default CreditCardDetails
